var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorybookSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.8791 471.791L50.0184 49.1749C49.4946 35.2175 60.1966 23.3888 74.1366 22.5175L433.601 0.0510042C447.791 -0.835823 460.012 9.94791 460.899 24.1371C460.932 24.6717 460.949 25.2073 460.949 25.7429V486.258C460.949 500.475 449.424 512 435.207 512C434.822 512 434.437 511.991 434.052 511.974L90.4481 496.542C77.066 495.941 66.3815 485.177 65.8791 471.791Z",
    fill: "#FF4785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.454 62.933L355.91 3.8787L405.275 0L407.402 60.9006C407.476 63.0201 405.818 64.7983 403.698 64.8723C402.791 64.904 401.901 64.613 401.188 64.0511L382.151 49.0545L359.612 66.1519C357.922 67.4336 355.513 67.1029 354.232 65.4132C353.692 64.702 353.417 63.8249 353.454 62.933ZM290.321 192.98C290.321 202.995 357.782 198.195 366.838 191.16C366.838 122.959 330.243 87.1208 263.231 87.1208C196.22 87.1208 158.674 123.517 158.674 178.111C158.674 273.196 286.994 275.015 286.994 326.88C286.994 341.438 279.865 350.082 264.182 350.082C243.746 350.082 235.666 339.645 236.617 304.159C236.617 296.461 158.674 294.061 156.298 304.159C150.247 390.155 203.824 414.959 265.132 414.959C324.54 414.959 371.115 383.294 371.115 325.97C371.115 224.061 240.894 226.791 240.894 176.291C240.894 155.818 256.102 153.089 265.132 153.089C274.637 153.089 291.747 154.764 290.321 192.98Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorybookSvg);
export default __webpack_public_path__ + "static/media/StorybookSVG.0af15849cb66bdc916c5cdf9d3e99abc.svg";
export { ForwardRef as ReactComponent };